import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { generateGlobalColumns, generateBasicColumn, IDataGridConfig, generateEntityColumn, IconTooltip } from '@ts/storybook';
import { CEGR, IConfigComponent, CEventType } from '@ts/ui-models';

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'EGRs',
  aclId: 'taEventGenerationRule',
  entity: 'eventGenerationRule',
  fetchURL: '/api/eventGenerationRules',
  crudURL: '/api/eventGenerationRule',
  mainClass: CEGR,
};
const EventGenerationRules = props => {
  //TODO: Add filter with props.id? from DeviceTypeEvents?
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const extraRenderCell = (params: GridRenderCellParams) => {
    const value = params.row?.hasWarning ?? false;
    if (value) {
      return <IconTooltip text={'Rule Overlap Warning'} tooltipType={'warning'} color="warning" />;
    } else {
      return null;
    }
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(undefined, undefined, undefined, extraRenderCell),
      generateBasicColumn({ field: 'actionLogicalId', headerName: 'Action' }, { field: 'actionLogicalId' }),
      generateEntityColumn(
        { field: 'eventType', headerName: 'Event type' },
        { tEntity: 'eventType', mainClass: CEventType },
        { inheritedProps }
      ),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      title={props.title}
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //extraActions={actions}
      dataGridMode={'server'}
      //From grandpa
      inheritedProps={props.inheritedProps}
    />
  );
};

export default EventGenerationRules;
